import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
import noAuthStack from 'hub-http/stacks/noAuthWithCredentialsHubapi';
export const insightsAppClient = promiseClient(createStack(coreMiddlewares.base('marketplace/insights/v1'), appAuthStack));
export const insightsPublicClient = promiseClient(createStack(coreMiddlewares.base('marketplace/insights/public/v1'), noAuthStack));
export function getInsightsClient(appContext) {
  return appContext === 'app' ? insightsAppClient : insightsPublicClient;
}